import React from "react";
import styles from "@src/components/helpers.module.scss";
import useSvgFillColor from "@src/hooks/useSvgFillColor";

export const LocationIcon: React.FC = () => {
	const fillColor = useSvgFillColor();

	return (
		<div className={styles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
				<path
					d="M13.8334 6.66683C13.8334 9.9955 10.1407 13.4622 8.90069 14.5328C8.78517 14.6197 8.64455 14.6667 8.50002 14.6667C8.35549 14.6667 8.21487 14.6197 8.09935 14.5328C6.85935 13.4622 3.16669 9.9955 3.16669 6.66683C3.16669 5.25234 3.72859 3.89579 4.72878 2.89559C5.72898 1.8954 7.08553 1.3335 8.50002 1.3335C9.91451 1.3335 11.2711 1.8954 12.2713 2.89559C13.2715 3.89579 13.8334 5.25234 13.8334 6.66683Z"
					stroke={fillColor}
					strokeWidth="0.666667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.5 8.6665C9.60457 8.6665 10.5 7.77107 10.5 6.6665C10.5 5.56193 9.60457 4.6665 8.5 4.6665C7.39543 4.6665 6.5 5.56193 6.5 6.6665C6.5 7.77107 7.39543 8.6665 8.5 8.6665Z"
					stroke={fillColor}
					strokeWidth="0.666667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};
